/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureDiskRestoreDestination } from '../models/AzureDiskRestoreDestination';

export class RestoreAzureDiskRequest {
  /**
  * Cloud-provider-assigned ID of the disk to restore.
  */
  'providerDiskId': string;
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': AzureDiskRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerDiskId",
      "baseName": "providerDiskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "AzureDiskRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAzureDiskRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

